module.exports = __webpack_public_path__ + "img/liz.ccd3002c.png";